export const LogoMark = ({ className = "w-10 h-10" }) => (
  <img src="/brand/first-due-emblem.webp" alt="" aria-hidden="true" width="256" height="259" className={`object-contain ${className}`} />
);

export const FullLogo = ({ className = "" }) => (
  <picture>
    <source srcSet="/brand/first-due-logo.webp" type="image/webp" />
    <img
      src="/brand/first-due-logo.png"
      alt="First Due Home Watch & Concierge — A Tradition of Service, A Commitment to Your Home"
      width="900"
      height="617"
      loading="lazy"
      className={`h-auto w-full object-contain ${className}`}
    />
  </picture>
);

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark className="h-11 w-11 shrink-0 md:h-12 md:w-12" />
    <span className="leading-none">
      <span className={`block font-display text-[1.45rem] font-bold tracking-[0.08em] ${light ? "text-white" : "text-[#14263D]"}`}>FIRST DUE</span>
      <span className={`block font-mono text-[0.6rem] tracking-[0.24em] mt-1 ${light ? "text-white/80" : "text-[#5F6B76]"}`}>HOME WATCH &amp; CONCIERGE</span>
    </span>
  </span>
);
